const COMPLETION_PENDING = 0;
const COMPLETION_SUCCESS = 1;
const COMPLETION_ERROR = 2;
const COMPLETION_CANCEL = 3;

export { COMPLETION_CANCEL, COMPLETION_ERROR, COMPLETION_PENDING, COMPLETION_SUCCESS };
//# sourceMappingURL=completion-states.js.map
